module.exports = __webpack_public_path__ + "static/media/cloud.70ee9d09.png";